
import { StyleValue } from '@/shared/app/model/StyleValue';
import Base from '@/shared/app/ui/Base.vue';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

@Component
export default class AutoFlex extends Base {
  scopedSlots: typeof Vue.prototype.$scopedSlots = {};

  get containerStyle(): StyleValue {
    return {
      flexDirection: this.flexDirection || 'row',
      alignItems: this.autoFlexConfig.alignItems?.toString() || 'stretch',
      justifyContent: this.autoFlexConfig.justifyContent?.toString() || 'flex-start',
      padding: this.autoFlexConfig.outerPadding?.toString() || '0',
    };
  }

  get flexDirection() {
    if (this.autoFlexConfig.vertical) {
      if (this.autoFlexConfig.reverse) return 'column-reverse';
      return 'column';
    }
    if (this.autoFlexConfig.reverse) return 'row-reverse';
    return 'row';
  }

  mounted() {
    this.slotsChange();
  }

  @Watch('pTemplate.slots')
  slotsChange() {
    this.$nextTick(() => {
      this.scopedSlots = {
        ...this.$scopedSlots,
      };
    });
  }

  slotStyle(name: string, first: boolean) {
    const style: StyleValue = {
      flexGrow: `${this.autoFlexConfig[`${name}Grow`] || this.autoFlexConfig.grow || '1'}`,
      flexShrink: `${this.autoFlexConfig[`${name}Shrink`] || this.autoFlexConfig.shrink || '1'}`,
      flexBasis: `${this.autoFlexConfig[`${name}Basis`] || this.autoFlexConfig.basis || 'auto'}`,
      padding:
        this.autoFlexConfig[`${name}Padding`]?.toString() ||
        this.autoFlexConfig.padding?.toString() ||
        '0',
      margin:
        this.autoFlexConfig[`${name}Margin`]?.toString() ||
        this.autoFlexConfig.margin?.toString() ||
        '0',
    };
    if (this.config.spaceBetween && !first) {
      if (this.config.vertical) style.paddingTop = this.config.spaceBetween.toString();
      else style.paddingLeft = this.config.spaceBetween.toString();
    }
    if (this.config[`${name}Order`]) style.order = this.config[`${name}Order`].toString();
    if (this.autoFlexConfig[`${name}AlignSelf`])
      style.alignSelf = this.autoFlexConfig[`${name}AlignSelf`].toString();
    if (this.autoFlexConfig[`${name}JustifySelf`])
      style.justifySelf = this.autoFlexConfig[`${name}JustifySelf`].toString();
    if (this.autoFlexConfig[`${name}Width`])
      style.width = this.autoFlexConfig[`${name}Width`].toString();
    if (this.autoFlexConfig[`${name}Height`])
      style.height = this.autoFlexConfig[`${name}Height`].toString();
    return style;
  }

  isDoneListened(slotName: string) {
    return this.autoFlexConfig[`${slotName}_done`] === '1';
  }

  get vertical() {
    return this.config.vertical === true;
  }

  get autoFlexConfig() {
    return this.config;
  }

  get slotsNames() {
    return Object.keys(this.scopedSlots);
  }
}
